// V1
import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./layout/layout";
import cookies from "js-cookie";
// ssg
import NotFound from "./pages/404/notFound";
import Home from "./pages/home/home";
import Contact from "./pages/contact/contact";
import Search from "./pages/search/search";
import News from "./pages/news/news";
import Policy from "./pages/policy/policy";
// ssr
import MainTemplate from "./pages/template";
import NewsTemplate from "./pages/news";

const App = ({ dynamicRoutes }) => {
  const defaultLanguage = cookies.get("i18next") || "am";
  
  return (
    <Routes>
      <Route
        path="/"
        element={<Navigate to={`/${defaultLanguage}`} replace />}
      />
      <Route path="/:language" element={<Layout />}>
        {/* Static Routes */}
        <Route index element={<Home />} />
        <Route path="contact" element={<Contact />} />
        <Route path="search" element={<Search />} />
        <Route path="news" element={<News />} />
        <Route path="personal" element={<Policy />} />
        <Route path="availability" element={<Policy />} />

        {/* Dynamic Routes */}
        {dynamicRoutes?.map((route) => {
          const isNews = route.type === "news";

          return (
            <Route
              key={route.unique_id}
              path={route.path}
              element={
                isNews ? (
                  <NewsTemplate {...route} />
                ) : (
                  <MainTemplate {...route} />
                )
              }
            />
          );
        })}

        {/* 404 Page */}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};
export default App;

// v2
// import { Navigate, Route, Routes } from "react-router-dom";
// import { Layout } from "./layout/layout";
// // ssg
// import NotFound from "./pages/404/notFound";
// import Home from "./pages/home/home";
// import Contact from "./pages/contact/contact";
// import Search from "./pages/search/search";
// import News from "./pages/news/news";
// import Policy from "./pages/policy/policy";
// // ssr
// import MainTemplate from "./pages/template";
// import NewsTemplate from "./pages/news";

// const App = ({ dynamicRoutes, defaultLanguage }) => {
//   if (!defaultLanguage) return null;

//   return (
//     <Routes>
//       <Route
//         path="/"
//         element={<Navigate to={`/${defaultLanguage}`} replace />}
//       />
//       <Route path="/:language" element={<Layout />}>
//         {/* Static Routes */}
//         <Route index element={<Home />} />
//         <Route path="contact" element={<Contact />} />
//         <Route path="search" element={<Search />} />
//         <Route path="news" element={<News />} />
//         <Route path="personal" element={<Policy />} />
//         <Route path="availability" element={<Policy />} />

//         {/* Dynamic Routes */}
//         {dynamicRoutes?.map((route) => {
//           const isNews = route.type === "news";

//           return (
//             <Route
//               key={route.unique_id}
//               path={route.path}
//               element={
//                 isNews ? (
//                   <NewsTemplate {...route} />
//                 ) : (
//                   <MainTemplate {...route} />
//                 )
//               }
//             />
//           );
//         })}

//         {/* 404 Page */}
//         <Route path="*" element={<NotFound />} />
//       </Route>
//     </Routes>
//   );
// };
// export default App;
